
    import React from 'react';
    import { NavLink } from 'react-router-dom';

    const NavItem = ({ path, name, icon: Icon, onClick }) => (
      <NavLink
        to={path}
        className={({ isActive }) =>
          `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200
          ${isActive 
            ? 'bg-primary/10 text-primary border border-primary/20' 
            : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground hover:border hover:border-border'
          }`
        }
        onClick={onClick}
      >
        {Icon && <Icon className="mr-2 h-4 w-4" />}
        {name}
      </NavLink>
    );

    export default NavItem;
  